import React from "react";
import { Check } from "lucide-react";

export const PHASES = ["Submitted", "Discovery", "Design", "Development", "Review", "Done"];

export function ProgressTracker({ status }) {
  const idx = Math.max(0, PHASES.indexOf(status));
  return (
    <div data-testid="progress-tracker" className="w-full">
      <div className="flex items-center">
        {PHASES.map((p, i) => {
          const done = i < idx;
          const current = i === idx;
          return (
            <React.Fragment key={p}>
              <div className="flex flex-col items-center gap-2">
                <div
                  className={`flex h-9 w-9 items-center justify-center rounded-full border text-xs font-mono transition-colors ${
                    done
                      ? "border-primary bg-primary text-white"
                      : current
                      ? "border-primary bg-primary/15 text-primary shadow-[0_0_18px_rgba(59,130,246,0.5)]"
                      : "border-white/15 bg-black text-zinc-500"
                  }`}
                >
                  {done ? <Check className="h-4 w-4" /> : i + 1}
                </div>
                <span className={`text-[10px] uppercase tracking-wider font-mono ${current ? "text-primary" : done ? "text-zinc-300" : "text-zinc-600"}`}>
                  {p}
                </span>
              </div>
              {i < PHASES.length - 1 && (
                <div className={`mx-1 h-px flex-1 ${i < idx ? "bg-primary" : "bg-white/10"}`} />
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
}
